// Revenue (LeverKey "Revenue", LeverSubkey "Excl. Exp Reimb.") is calculated from the
// SOW / Pipeline data (Booked + Extension + Pipeline) and cannot be edited.
// An account with SOW / Pipeline rows: the server puts their sums into the calculation.
// An account without them: the browser sends the SAVED Revenue as the input, so it is kept
// as it is and the calculated-vs-predicted check shows no difference.
// Keep in step with OneData-Api-Backend/controllers/sowRevenue.js.

export const SOW_CATEGORIES = ['Booked', 'Extension', 'Pipeline'];
export const REVENUE_LABEL = 'Revenue · Excl. Exp Reimb.';
export const REVENUE_LOCKED_TIP =
  'Calculated from the SOW / Pipeline data (Booked + Extension + Pipeline) - Read Only. Use Bulk Edit > SOW & Pipeline to change it.';

const MONTH_RE = /^[A-Z][a-z]{2}-\d{2}$/;
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const norm = (v) =>
  String(v === null || v === undefined ? '' : v)
    .trim()
    .toLowerCase();

export const isRevenueRow = (row) =>
  !!row &&
  norm(row.LeverKey ?? row.leverKey) === 'revenue' &&
  norm(row.LeverSubkey ?? row.leverSubkey) === 'excl. exp reimb.';

// "Oct-26" -> sortable number
export const monthScore = (m) => {
  const [mon, yy] = String(m || '').split('-');
  const idx = MONTHS.indexOf(mon);
  return idx < 0 || !yy ? 0 : (2000 + parseInt(yy, 10)) * 12 + idx;
};

// The saved Revenue of the predicted months as engine overrides:
// -> { leverId, values: { 'Nov-26': 450, ... } } or null when nothing is saved
export const savedRevenueOverride = (predictedData, rawPayload) => {
  const revRows = (predictedData || []).filter(isRevenueRow);
  if (revRows.length === 0) return null;
  const leverId =
    (rawPayload || []).find(isRevenueRow)?.LeverBaseId || 'revenueexcl.expreimb.';
  const actualMonths = new Set(Object.keys(rawPayload?.[0] || {}));
  // the editable row first (Section 1), then any other Revenue row
  const ordered = [...revRows].sort(
    (a, b) =>
      (Number(b.Editable ?? b.EDITABLE) === 1 ? 1 : 0) -
      (Number(a.Editable ?? a.EDITABLE) === 1 ? 1 : 0),
  );
  const values = {};
  ordered.forEach((row) => {
    Object.keys(row).forEach((m) => {
      if (!MONTH_RE.test(m) || actualMonths.has(m) || values[m] !== undefined) return;
      const v = row[m];
      if (v === null || v === undefined || v === '' || !isFinite(Number(v))) return;
      values[m] = Number(v);
    });
  });
  return Object.keys(values).length ? { leverId, values } : null;
};
